'use client';

import { Modal } from '@mokoboko/components';

import { type TermsTagValues } from '@/helpers/terms';
import type { ResolvedTerms } from '@/services/terms';
import { TermsDocumentContent } from './terms-document-content';

export const TermsModal = ({
  doc,
  onClose,
  tagValues,
}: {
  doc: ResolvedTerms | null;
  onClose: () => void;
  tagValues?: TermsTagValues;
}) => (
  <Modal.Root
    open={!!doc}
    onOpenChange={(open) => {
      if (!open) onClose();
    }}
  >
    <Modal.Content size="full" hasCloseButton>
      <Modal.Header>
        <Modal.Title>{doc?.title ?? ''}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {doc ? <TermsDocumentContent doc={doc} tagValues={tagValues} /> : null}
      </Modal.Body>
    </Modal.Content>
  </Modal.Root>
);
